import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { ErrorCommon, TextField, TextFieldCommon } from "../../../../../components/formikFormInputs";
import { Label } from "../../../../../components/formInputs";


interface giftorDetailsProps {
    values:any, handleChange:Function,
    errors:any, touched:any,
    setIsPolicyDirty:Function,
    disabled: boolean
}


function GiftorDetails(props: giftorDetailsProps) {
    const { values, handleChange, errors, touched,
        disabled = true } = props;

    const fieldObj = [
        {
            name: "giftorFirstName",
            label: <Label label={"First Name"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
            disabled
        },
        {
            name: "giftorLastName",
            label: <Label label={"Last Name"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
            disabled
        },  {
            name: "giftorEmail",
            label: <Label label={"Giftor Email"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
            disabled
        },
        {
            name: "giftorPhoneNumber",
            label: <Label label={"Giftor Phone Number"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
            disabled
        },
        {
            name: "giftorContribution",
            label: <Label label={"Giftor Contribution Amount"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
            disabled
        },
        {
            name: "relationWithChild",
            label: <Label label={"Relation to the Child"} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
            disabled
        },
    ];

    return (
            <>
                <Typography variant="subtitle1" component="strong" className="mb10 mt30 floatLeft w100">Giftor Details</Typography>

                <Grid container spacing={3}>
                    {
                        fieldObj.map((field, index) => {
                            return (
                                    <Grid item xs={12} md={6} xl={4} key={index} className="mb15">
                                        <TextFieldCommon
                                                {...field}
                                                values={values}
                                                onChange={handleChange}
                                        />
                                        <ErrorCommon errors={errors} name={field.name}
                                                     touched={touched} />
                                    </Grid>
                            );
                        })
                    }
                </Grid>
            </>
    );
}

export default GiftorDetails;